import { render, staticRenderFns } from "./PageNotAllowed.vue?vue&type=template&id=541f59a8&scoped=true&lang=html&"
import script from "./PageNotAllowed.vue?vue&type=script&lang=js&"
export * from "./PageNotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./PageNotAllowed.vue?vue&type=style&index=0&id=541f59a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f59a8",
  null
  
)

export default component.exports